<template>
  <div :class="isCheckoutPage ? 'marketplace-checkout' : 'container'">
    <vue-snotify />
    <router-view />
  </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from 'vuex';
import t from '../../main/i18n';

export default {
  created() {
    this.$root.$on('designspec:share', project => {
      this.$snotify.success(
        `${project.name} ${t('DesignSpec has been shared')}. ${t('An email has been sent with a link to your project')}`,
        {closeOnClick: true}
      );
    });
  },
  computed: {
    ...mapGetters('auth', ['authenticated']),
    ...mapState('auth', ['status', 'newRegistration']),
    ...mapState('marketplace', ['cartId']),
    ...mapState('designspec', ['projects']),
    isCheckoutPage() {
      const body = document.querySelector('body');
      if (this.$route.name === 'marketplace-checkout') {
        body.classList.add('is-marketplace-checkout');
      } else {
        body.classList.remove('is-marketplace-checkout');
      }

      return this.$route.name === 'marketplace-checkout';
    }
  },
  watch: {
    async authenticated(is, was) {
      if (is && !was) {
        if (!this.isCheckoutPage) {
          await this.getCurrentCart({sync: false, mergeCart: true});
        }
        await this.handleAuthenticationSwitch(is);
      }
      if (was && !is) {
        let queryParams ='';

        if (this.status === 'reset_password') {
          this.$snotify.success(t('Password successfully reset, please sign in'));
        } else if (this.status === 'user_email_change') {
          this.$snotify.success(t('Email successfully changed! You have been signed out for security purposes, please sign in again.'));
        } else if (this.status === 'refresh_token_failed') {
          queryParams = `?sessionExpired=1&redirect=${window.location.pathname}${window.location.search}`;
          this.$snotify.info(
            t('Your session expired, please sign in again'),
            {timeout: 4000}
          );
        } else {
          this.$snotify.clear();
          this.$snotify.success(t('Successfully signed out'));
        }

        await this.$router.replace(`/marketplace/auth/login${queryParams}`);
      }
    }
  },
  methods: {
    ...mapActions('marketplace', ['getCurrentCart']),
    ...mapActions('designspec', ['createProject']),
    async handleAuthenticationSwitch(authenticated) {
      window.scrollTo(0, 0);

      const project = this.projects[0];
      if (
        project
        && this.$router.currentRoute.path.includes('/project')
        && !this.$router.currentRoute.path.endsWith('/share')
      ) {
        project.id = null;
        const id = await this.createProject(project);
        return await this.$router.replace(`/designspec/project/${id}`);
      }

      if (
        authenticated
        && this.status !== 'refresh_token_failed'
        && this.isCheckoutPage
      ) {
        return;
      }

      this.$snotify.clear();

      if (!this.$router.currentRoute.path.endsWith('/checkout')) {
        await this.$router.push({name: 'marketplace-account-orders'});
      }

      if (this.newRegistration) {
        this.$snotify.success(t('Your account has been created!'));
      } else {
        this.$snotify.success(t('Welcome back!'));
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';

/* Overrides */
.path-marketplace,
.path-designspec {
  margin-bottom: 0;

  .site-header #block-sloan-breadcrumbs {
    display: none !important;
  }

  & > div > main {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: calc(100vh - 128px);
    margin-top: 128px !important;
    background: $color-white;
  }
}

.dialog-off-canvas-main-canvas > main {
  @media print {
    margin-top: 0 !important;
  }
}

.site-header {
  @media print {
    display: none !important;
  }
}

.is-marketplace-checkout {
  .site-header,
  .site-footer {
    display: none;
  }

  main {
    margin-top: 0 !important;
  }
}
</style>
